import requestCtxs from '@/sealFilter/requestCtxs'


//二级分类
export function queryflxxbyCondition (data) {
    return requestCtxs({
        url: '/whgs/api/queryflxxbyCondition',
        method: 'post',
        data
    })
}

//头部的一级分类
export function queryTreeflxx (data) {
    return requestCtxs({
        url: '/whgs/api/queryTreeflxx',
        method: 'post',
        data
    })
}

//添加或更新阅读推荐
export function queryBookTjbyCondition (data) {
    return requestCtxs({
        url: '/whgs/api/queryBookTjbyCondition',
        method: 'post',
        data
    })
}

//获取日历时间
export function weekdaybydate (data) {
    return requestCtxs({
        url: '/whgs/api/weekdaybydate',
        method: 'post',
        data
    })
}
// 登录用户信息
export function queryUserinfobycondition (data) {
    return requestCtxs({
        url: '/whgs/api/queryUserinfobycondition',
        method: 'post',
        data
    })
}

// 清除缓存
export function clearUser(data) {
    return requestCtxs({
        url: '/whgs/api/caslogout',
        method: 'post',
        data
    })
}

// 站内搜索
export function searchStation(data) {
    return requestCtxs({
        url: '/whgs/api/queryGjcCondition',
        method: 'post',
        data
    })
}


export function queryCaDalbycondition(data) {
    return requestCtxs({
        url: '/whgs/api/queryCaDalbycondition',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/context1.js